import React, { useState, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  LayerGroup,
  Marker,
  Popup,
  useMapEvents,
  Tooltip,
  useMapEvent,
  Polyline,
  LayersControl
} from "react-leaflet";
import MapPopUp from "../MapPopUp/MapPopUp";
import "./CustomMap.css";
import L from "leaflet";
import { MarkerState } from "../../../Context/MapMarkerContext/MapMarkerContext";

const CustomMap = ({
  coordinates,
  showActionBox = false,
  showStatus = false,
  chooseCoordinates,
  zoom,
  popUpShow,
  closeMapModal,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [showToolBar, setShowToolBar] = useState(false);
  const { setMarkerId } = MarkerState();
  const mapRef = useRef();
  
  const handleClick = (e) => {
    const { lat, lng } = e.latlng;
    console.log("Latitude:", e.latlng.lat);
    console.log("Longitude:", e.latlng.lng);
    chooseCoordinates(lng, lat);
    if(closeMapModal) {
      closeMapModal();
    }
  };
  
  // Custom hook to handle map events
  const MapClickHandler = () => {
    useMapEvents({
      click: handleClick,
    });
    return null;
  };
 
  const markerClick = (event, markerId) => {
    const id = event.target.options.index;
    setShowToolBar(true);
    setSelectedIndex(id); //get index via custom marker property
    setMarkerId(markerId); //to set the marker in context
  };
 
  const SetViewOnClick = ({ animateRef }) => {
    const map = useMapEvent("click", (e) => {
      map.setView(e.latlng, map.getZoom(), {
        animate: animateRef.current || false,
      });
    });
 
    return null;
  };
  
  const PopUoCloser = () => {
    const map = useMapEvents({
      click(e) {
        setShowToolBar(false);
        setSelectedIndex(-1);
        setMarkerId(0); //to set the marker in context
      },
    });
    return null;
  };
 
  const center = coordinates?.reduce(
    (acc, loc) => [
      acc[0] + loc.x / coordinates.length,
      acc[1] + loc.y / coordinates.length,
    ],
    [0, 0]
  );
  const animateRef = useRef(false);
  const blueIcon = new L.Icon({
   iconUrl: 'data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0iYmFzaWMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ4IDQ4IiBmaWxsPSIjZjQ0MzM2Ij48cGF0aCBkPSJNMjQgNGMtNy43MyAwLTE0IDYuMjctMTQgMTQgMCAxMC41IDE0IDI2IDE0IDI2czE0LTE1LjUgMTQtMjZjMC03LjczLTYuMjctMTQtMTQtMTR6bTAgMTkuMWMtMi44MSAwLTUuMS0yLjI5LTUuMS01LjFzMi4yOS01LjEgNS4xLTUuMSA1LjEgMi4yOSA1LjEgNS4xLTIuMjkgNS4xLTUuMSA1LjF6Ii8+PC9zdmc+',
   iconSize: [40, 40],
   iconAnchor: [20, 40],
   popupAnchor: [0, -40]
 });
 
  // Create custom marker icon based on location type
  const createMarkerIcon = (location) => {
    const locationType = location?.popupdata?.type || "Default";
    
    if (locationType === "Bank") {
      return L.divIcon({
        className: 'custom-div-icon',
        html: `<div style="background-color: #1a7a73; color: white; padding: 5px; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="4" y="4" width="16" height="16" rx="1"></rect>
                  <line x1="4" y1="9" x2="20" y2="9"></line>
                  <line x1="9" y1="20" x2="9" y2="9"></line>
                  <line x1="15" y1="20" x2="15" y2="9"></line>
                </svg>
              </div>`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30]
      });
    } else if (locationType === "Branch") {
      return L.divIcon({
        className: 'custom-div-icon',
        html: `<div style="background-color: #FFA100; color: white; padding: 5px; border-radius: 50%; width: 25px; height: 25px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18"></path><path d="M5 21V7l8-4v18"></path><path d="M19 21V11l-6-4"></path><path d="M9 9v.01"></path><path d="M9 12v.01"></path><path d="M9 15v.01"></path><path d="M9 18v.01"></path></svg>
              </div>`,
        iconSize: [25, 25],
        iconAnchor: [12.5, 25],
        popupAnchor: [0, -25]
      });
    } else {
      // Default marker
      return L.divIcon({
        className: 'custom-div-icon',
        html: `<div style="background-color: #1a7a73; color: white; padding: 5px; border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </div>`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
        popupAnchor: [0, -30]
      });
    }
  };

  console.log("marker.popupdata",coordinates)

  // Check if coordinates exist
  if (!coordinates || coordinates.length === 0) {
    return (
      <div style={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        color: '#666'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '10px' }}>
            <span role="img" aria-label="map">🗺️</span>
          </div>
          <p>No location data available</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {showToolBar && showActionBox}
      <MapContainer
        zoom={zoom}
        scrollWheelZoom={true}
        center={center}
        style={{ height: "100%", position: "sticky" }}
        attributionControl={false}
      >
        <PopUoCloser />
        <LayersControl position="topright" collapsed={false}>
          <LayersControl.BaseLayer name="Road View">
            <TileLayer
              // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Satellite View">
            <TileLayer
              // attribution="&copy; Google Maps"
              url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
              maxZoom={20}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer checked name="Terrain View">
            <TileLayer
              // attribution="&copy; Google Maps"
              url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
              maxZoom={20}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Hybrid View">
            <TileLayer
              // attribution="&copy; Google Maps"
              url="https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
              maxZoom={20}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
          </LayersControl.BaseLayer>
        </LayersControl>

        {coordinates.map((marker, index) => (
          <Marker
             icon={blueIcon}
            key={index}
            index={index}
            center={[marker.x, marker.y]}
            position={[marker.x, marker.y]}
            eventHandlers={{
              click: (event) => {
                markerClick(event, marker?.locationId);
              },
            }}
          >
            {popUpShow && marker.popupdata && (
             <Popup>
  <div style={{ minWidth: '200px' }}>
    <h6 
      style={{ 
        margin: '0 0 5px 0', 
        color: marker.popupdata.type === "Bank" ? "#1a7a73" : "#FFA100", 
        fontWeight: 'bold' 
      }}
    >
      {marker.popupdata.title || "Unknown Location"}
    </h6>
    {/* Uncomment and add type if needed */}
    <div>
      <strong>Type:</strong> {marker.popupdata.type || "Unknown"}
    </div>
    {marker.popupdata.status && (
      <div style={{ marginBottom: '5px', marginTop: "5px" }}>
        <strong>Status:</strong> 
        <span 
          style={{ color: marker.popupdata.status === "Active" ? "green" : "red" }}
        >
          {marker.popupdata.status || "Unknown"}
        </span>
      </div>
    )}
    {marker.popupdata.email && (
      <div style={{ marginBottom: '5px' }}>
        <strong>Email:</strong> {marker.popupdata.email}
      </div>
    )}
        {marker.popupdata.contact && (
      <div style={{ marginBottom: '5px' }}>
        <strong>Contact:</strong> {marker.popupdata.contact}
      </div>
    )}
    {/* Address: Only show if address is available */}
    {marker.popupdata.description && (
      <div style={{ marginBottom: '5px' }}>
        <strong>Address:</strong> {marker.popupdata.description}
      </div>
    )}  
  </div>
</Popup>

            )}
          </Marker>
        ))}
        <MapClickHandler />
        <SetViewOnClick animateRef={animateRef} />
      </MapContainer>
    </>
  );
};

export default CustomMap;